<template>
  <div
    :href="href"
    class="LKAsideMenuSubmenuHeader"
  >
    <div class="text-h4 mod--nav mod--grey" v-text="label" />
  </div>
</template>

<script>

export default {
  name: 'LKAsideMenuSubmenuHeader',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.LKAsideMenuSubmenuHeader {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  cursor: pointer;
  background-color: $webflow-color-blue-shadow;
  border-bottom: 1px solid $webflow-color-blue-light;
}
</style>

